module.exports = __webpack_public_path__ + "static/media/image020.fbd20c26.jpg";